/** @format */
import lang_route from './lang_route.json';

const swedish = {
  lang_route
};

export default swedish;
